/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsUserTrialListItem,
    MelcoModelsUserTrialListItemFromJSON,
    MelcoModelsUserTrialListItemFromJSONTyped,
    MelcoModelsUserTrialListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsUserTrialListItem
 */
export interface MelcoModelsGenericList1MelcoModelsUserTrialListItem {
    /**
     * 
     * @type {Array<MelcoModelsUserTrialListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserTrialListItem
     */
    list: Array<MelcoModelsUserTrialListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserTrialListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsUserTrialListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsUserTrialListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsUserTrialListItem {
    return MelcoModelsGenericList1MelcoModelsUserTrialListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsUserTrialListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsUserTrialListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsUserTrialListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsUserTrialListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsUserTrialListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsUserTrialListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


